export default class CaseFinanceModel {
  constructor() {
    this.caseId = '';
    this.displayId = '';
    this.name = '';
    this.memberId = '';
    this.cellphone = '';
    this.carId = '';
    this.vendor = '';
    this.category = '';
    this.totalCreditPrice = '';
    this.creditPriceMonth = '';
    this.agentId = '';
    this.createdDate = new Date();
    this.updatedDate = new Date();
    this.installmentsNumber = '';
    this.fileURL1 = '';
    this.fileURL2 = '';
    this.fileURL3 = '';
    this.fileURL4 = '';
    this.fileURL5 = '';
    this.fileURL6 = '';
    this.fileURL7 = '';
    this.fileURL8 = '';
  }
}



// WEBPACK FOOTER //
// ./src/models/CarFinanceModel.js